import React from 'react';
import './AccountDeletion.css';

const AccountDeletion = () => {
  return (
    <div className="account-deletion">
      <div className="deletion-header container">
        <h1>MIMIC 계정/데이터 삭제 요청 방법</h1>
      </div>

      <div className="deletion-content container">
        <section className="deletion-section">
          <h2>1. 개발자 및 앱 정보</h2>
          <ul>
            <li><strong>개발자</strong>: BenefitBros (베네핏브로스)</li>
            <li><strong>앱 이름</strong>: MIMIC (미믹)</li>
          </ul>
        </section>

        <section className="deletion-section">
          <h2>2. 계정/데이터 삭제 요청 방법</h2>
          <p>
            계정 및 데이터 삭제를 원하시면 아래 이메일로 요청해 주세요.
          </p>
          <div className="contact-box">
            <p><strong>이메일</strong>: <a className="link" href="mailto:master@mimic.blog">master@mimic.blog</a></p>
            <p className="note-text">※ 이메일 제목에 "계정 삭제 요청"을 명시해 주시면 더욱 빠른 처리가 가능합니다.</p>
          </div>
        </section>

        <section className="deletion-section">
          <h2>3. 삭제되는 데이터</h2>
          <p>계정 삭제 요청 시 다음 데이터가 영구적으로 삭제됩니다.</p>
          <ul>
            <li><strong>이메일 정보</strong>: 계정에 연결된 사용자 이메일 주소</li>
            <li><strong>남은 사용시간 재화 정보</strong>: 앱 내 구매한 사용 가능 시간 및 관련 정보</li>
          </ul>
          <p className="warning">⚠️ 삭제된 데이터는 복구할 수 없으니 신중히 결정해 주세요.</p>
        </section>

        <section className="deletion-section">
          <h2>4. 처리 기간</h2>
          <p>
            계정/데이터 삭제 요청은 <strong>요청 접수 후 즉시 처리</strong>됩니다.
          </p>
          <p>
            처리가 완료되면 요청하신 이메일 주소로 완료 안내를 보내드립니다.
          </p>
        </section>

        <section className="deletion-section">
          <h2>5. 문의</h2>
          <p>
            계정 삭제와 관련하여 궁금한 사항이 있으시면 언제든지 아래 이메일로 문의해 주세요.
          </p>
          <p>
            <a className="link" href="mailto:master@mimic.blog">master@mimic.blog</a>
          </p>
        </section>
      </div>

      <div className="deletion-footer container">
        <p>최종 수정일: 2025년 12월</p>
      </div>
    </div>
  );
};

export default AccountDeletion;

